import { render, staticRenderFns } from "./autoRecord.vue?vue&type=template&id=7397fcf7&scoped=true"
import script from "./autoRecord.vue?vue&type=script&lang=js"
export * from "./autoRecord.vue?vue&type=script&lang=js"
import style0 from "./autoRecord.vue?vue&type=style&index=0&id=7397fcf7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7397fcf7",
  null
  
)

export default component.exports